import logo from './logo.svg';
import gif from './time-to-stop-lol.gif'
import './App.css';
import React from 'react';
import { useState } from 'react';
import { initializeApp } from 'firebase/app'
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={gif} alt="it's time.. to stop"/>
        <div className='form1'>
          <HoursCalculatorForm/>
        </div>
      </header>
    </div>
  );
}

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCjZcN1ltEQoiA-e9k1LWD1163yrJ9s0d4",
//   authDomain: "engineeringiscool-31007.firebaseapp.com",
//   databaseURL: "https://engineeringiscool-31007.firebaseio.com",
//   projectId: "engineeringiscool-31007",
//   storageBucket: "engineeringiscool-31007.appspot.com",
//   messagingSenderId: "596093947277",
//   appId: "1:596093947277:web:365871e6e4b7f16e0901c4",
//   measurementId: "G-SYT0FX2YSQ"
// };

// // Initialize Firebase
// const apps = initializeApp(firebaseConfig);
// // const analytics = getAnalytics(app);

function HoursCalculatorForm() {
  const [inputs, setInputs] = useState({});

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}))
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    var timeBegin = parseTime(inputs.hoursBegin).getTime();
    var timeEnd = parseTime(inputs.hoursEnd).getTime();
    var timeBreak = parseTime(inputs.hoursBreak).getTime();
    var magicHour = parseTime("00:00").getTime();
    var breakTime = -1*(magicHour-timeBreak)/1000/60/60;
    var diff = (timeEnd - timeBegin)/1000/60/60;
    diff = diff - breakTime;
    alert(diff.toFixed(1));
    // console.log(diff/1000/60/60);
    // alert(timeBegin);
  }

  return (
    <form onSubmit={handleSubmit}>
      <div>
      <label>
        WHEN U MEET:
        <input
          type="time"
          name="hoursBegin"
          value={inputs.hoursBegin}
          onChange={handleChange}/>
      </label>
      </div>
      <div>
      <label>
        WHEN U LEAVE:
        <input
          type="time"
          name="hoursEnd"
          value={inputs.hoursEnd}
          onChange={handleChange}/>
      </label>
      </div>
      <div>
      <label>
        WHEN U BREAK??:
        <input
          type="time"
          name="hoursBreak"
          value={inputs.hoursBreak}
          onChange={handleChange}/>
      </label>
      </div>
      <input type="submit"/>
    </form>
  )
  
}


function parseTime( t ) {
  var d = new Date();
  var time = t.match( /(\d+)(?::(\d\d))?\s*(p?)/ );
  console.log(time);
  d.setHours( parseInt( time[1]) + (time[3] ? 12 : 0) );
  d.setMinutes( parseInt( time[2]) || 0 );
  console.log(d);
  return d;
}
export default App;
